import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock, Calendar, Sun, Moon, Send, ArrowUp, Facebook, Instagram, Linkedin, Youtube, Video } from "lucide-react";
import "animate.css";

// Interface pour l'affichage
interface DisplayHour {
  day: string;
  hours: string;
  isClosed: boolean;
  icon: React.ElementType;
}

const Footer: React.FC = () => {


  return (
    <>

      <footer>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem distinctio aliquam optio neque nihil architecto ut nemo repellat quisquam mollitia? Alias repudiandae excepturi ullam consectetur, natus impedit libero? Est, aperiam!
      </footer>

    </>
  );
};

export default Footer;